// src/components/SpeakerSlider.js
import React, {useEffect, useRef, useState} from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import {FreeMode, Navigation} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import arrowIcon from '../assets/img/icon_arrow.svg';
import arrowDown from '../assets/img/icon_arrow_down.svg';
import $ from 'jquery';
import {useDateSpeaker} from "../hooks/useDateSpeaker";
import ErrorAlert from "./ErrorAlert";
import Loading from "./Loading";

const SpeakerSlider = (props) => {
    const swiperRef = useRef(null);

    const [sliderCollapsed, setSliderCollapsed] = useState(false);

    const {data: speakerData, isLoading: isSpeakerLoading, isError: isSpeakerError} = useDateSpeaker();

    useEffect(() => {
        const nextBtn = document.querySelector('.slider-button-next');
        const prevBtn = document.querySelector('.slider-button-prev');

        const handleNext = () => {
            const swiper = swiperRef.current;
            if (swiper) {
                swiper.slideTo(swiper.activeIndex + swiper.params.slidesPerView - 1);
            }
        };

        const handlePrev = () => {
            const swiper = swiperRef.current;
            if (swiper) {
                swiper.slideTo(swiper.activeIndex - swiper.params.slidesPerView - 1);
            }
        };

        nextBtn?.addEventListener('click', handleNext);
        prevBtn?.addEventListener('click', handlePrev);

        return () => {
            nextBtn?.removeEventListener('click', handleNext);
            prevBtn?.removeEventListener('click', handlePrev);
        };
    }, []);

    // 共用的 slide 元素
    const slides = (
        <>
            {isSpeakerLoading && <Loading/>}
            {isSpeakerError && <ErrorAlert/>}
            {!isSpeakerLoading && speakerData.content.map((speaker, index) => (
                <SwiperSlide key={index} className="swiper-slide item">
                    <a className="card" href="#!" onClick={() => props.onOpenPopup(speaker)}>
                        <figure>
                            <div className="card_pic">
                                <img src={speaker.logoLargeImageIdUrl} alt="講師照片"/>
                            </div>
                        </figure>
                        <figcaption>
                            <span className="card_name">{speaker.name}</span>
                            <span className="card_company">{speaker.company}</span>
                            <span className="card_job">{speaker.jobTitle}</span>
                        </figcaption>
                    </a>
                </SwiperSlide>
            ))}
            {/* 依需求可繼續新增其他 SwiperSlide */}
        </>
    );

    const hideSlider = () => {
        setSliderCollapsed(true);
        const targetOffset = $("#topic_speaker").offset()?.top - 80 || 0;
        $("html, body").animate({scrollTop: targetOffset}, 500);
    };

    const showSlider = () => {
        setSliderCollapsed(false);
        const targetOffset = $("#topic_speaker").offset()?.top - 80 || 0;
        $("html, body").animate({scrollTop: targetOffset}, 500);
    };

    return (
        <>
            {!sliderCollapsed ? (
                <div className="slider-container swiperSpeaker">
                    <div className="slider-button-prev">
                        <img src={arrowIcon} alt="Prev Arrow"/>
                    </div>
                    <div className="swiper product-slider">
                        <Swiper
                            onSwiper={(swiper) => (swiperRef.current = swiper)}
                            className="swiper-wrapper"
                            modules={[Navigation, FreeMode]}
                            spaceBetween={0}
                            slidesPerView={1.5}
                            freeMode={true}
                            loop={false}
                            navigation={{
                                nextEl: '.slider-button-next',
                                prevEl: '.slider-button-prev',
                            }}
                            breakpoints={{
                                575: {slidesPerView: 2.5, spaceBetween: 0},
                                768: {slidesPerView: 3.5, spaceBetween: 0},
                                992: {slidesPerView: 3, spaceBetween: 0},
                                1200: {slidesPerView: 4, spaceBetween: 0},
                            }}
                        >
                            {slides}
                        </Swiper>
                    </div>
                    <div className="slider-button-next">
                        <img src={arrowIcon} alt="Next Arrow"/>
                    </div>
                </div>
            ) : (
                <div className="slider-container openSpeaker">
                    <Swiper
                        className="swiper-wrapper"
                        modules={[FreeMode]}
                        spaceBetween={0}
                        slidesPerView={1.5}
                        freeMode={true}
                        loop={false}
                        breakpoints={{
                            575: {slidesPerView: 2.5, spaceBetween: 0},
                            768: {slidesPerView: 3.5, spaceBetween: 0},
                            992: {slidesPerView: 3, spaceBetween: 0},
                            1200: {slidesPerView: 4, spaceBetween: 0},
                        }}
                    >
                        {slides}
                    </Swiper>
                </div>
            )}
            {!sliderCollapsed ? (
                <a href="#!" onClick={hideSlider} className="btn_start hideSlider">
                    <b>顯示全部</b>
                    <span>
            <img src={arrowDown} alt="Expand Arrow"/>
          </span>
                </a>
            ) : (
                <a href="#!" onClick={showSlider} className="btn_start showSlider">
                    <b>收合顯示</b>
                    <span>
            <img src={arrowDown} alt="Collapse Arrow"/>
          </span>
                </a>
            )}
        </>
    );
};

export default SpeakerSlider;
